import React from 'react';
import PropTypes from 'prop-types';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import GigCardCarouselWrapper from '../shared/GigCardCarouselWrapper';
import SafePureComponent from '../shared/SafePureComponent';
import { OTHER_GIGS_BY } from '../../utils/carousels';

const OtherGigsBy = (props, context) => {

    const formatBoxTitle = () => {
        const { isStudio } = general;
        let sellerName = requestContext.params.username;
        let sellerUrl = pathfinderWrapper.pathfinder('short_user', {id: sellerName});

        if (isStudio) {
            const { name, slug } = studioInfo;
            sellerUrl = pathfinderWrapper.pathfinder('studio_page', {slug});
            sellerName = name;
        }

        return (<I18n k="gig_page_perseus.recommended_gigs.more_services_by.title" parseMarkup={true}
            params={{seller_url: sellerUrl, seller_name: sellerName}}/>);
    };

    const {
        collections,
        updateCollections,
        isTouch,
        isLoggedIn,
        otherGigs,
        studioInfo
    } = props;

    const { pathfinderWrapper, requestContext, general } = context;
    const { gigIds } = otherGigs;

    if (!gigIds.length) {
        return null;
    }

    const ajaxUrl = pathfinderWrapper.pathfinder('gig_page_fetch_other_gigs_by', {gigIds});

    return (
        <GigCardCarouselWrapper boxTitle={formatBoxTitle()}
            boxClass="gigs-other-gigs-by"
            boxLocation="bottom"
            carouselPosition={2}
            collections={collections}
            isLoggedIn={isLoggedIn}
            isTouch={isTouch}
            updateCollections={updateCollections}
            type={OTHER_GIGS_BY}
            url={ajaxUrl}
            source="other_gigs_by"
            carouselContext={null}
            gigIds={gigIds}/>
    );
};

OtherGigsBy.propTypes = {
    collections: PropTypes.object,
    updateCollections: PropTypes.func,
    isTouch: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    otherGigs: PropTypes.shape({
        gigIds: PropTypes.arrayOf(PropTypes.number)
    }),
    studioInfo: PropTypes.object
};

OtherGigsBy.contextTypes = {
    pathfinderWrapper: PropTypes.object,
    requestContext: PropTypes.object,
    general: PropTypes.object
};

export { OtherGigsBy };
export default SafePureComponent(OtherGigsBy);
